/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Site title
  // wp.customize('blogname', function(value) {
  //   value.bind(function(to) {
  //     $('.brand').text(to);
  //   });
  // });

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
       
        /* ----------------------------------------------------
          Notifications banner placement */
        function notifications_banner() {
          if($("#notifications-banner").length > 0) {
            if($("#notifications-banner").hasClass('fixed-bottom')) {
              $('body').css('padding-bottom', $("#notifications-banner").outerHeight());
            }
            else {
              $('body').css('padding-top', $("#notifications-banner").outerHeight());
            }
          }
        }
        $(window).resize(function() { notifications_banner(); });
        $(window).load(function(){ notifications_banner(); }); // onload     

        /* End notifications banner 
           ----------------------------------------------------*/


        $(window).load(function(){ 
          $('a[href^="#"]:not([data-toggle="collapse"]:not([data-slide])').on('click',function (e) {

             // if($(this).attr('data-slide')) { return; }

              e.preventDefault();

              var target = this.hash;
              var $target = $(target);

              $('html, body').stop().animate({
                  'scrollTop': $target.offset().top - 120
              }, 900, 'swing', function () {
                  window.location.hash = target;
              });
          });

        });

        // -----------------------
        //  Main Menu
        var $menu = $('#navbarLayout');
        var $navbar_toggle = $('#navbar-toggler');

        // -----------------------
        // Hamburger menu
        function showMenu() {
          $menu.fadeIn(300);
        }

        function hideMenu() {
          $menu.fadeOut(300);
        }

       // Handler for pressing Escape key -- trigger click event above
        $(document).on('keyup',function(event) {
          if (event.keyCode === 27) {
            hideMenu();
          }
        });

        // Matchheight
        $(".layout-memberships .thumbnail").matchHeight();
        

        window.sr = new ScrollReveal();
       //sr.reveal('.navbar-brand');
        sr.reveal('.sr');

        // Go to link in block
        $('.layout-panel, .layout-block-panel').css('cursor', 'pointer').on('click tap press', function(e){
          if(e.target.nodeName === 'I') {
            return false;
          }
          var $href = $(this).find("a").attr("href");
          e.preventDefault();

          if($href.length>0) {
            window.location = $href;
          }
          return false;
        });
        //.on('mouseover', function(e) {
        //   $(this).find('h2, h3').addClass('text-dark animated infinite pulse');
        // }).on('mouseout', function(e) {
        //   $(this).find('h2, h3').removeClass('text-dark animated infinite pulse');
        // });



      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {

        $(".carousel .carousel-item .testimonial").matchHeight();
        $.fn.matchHeight._update();

        $.fn.matchHeight._afterUpdate = function(event, groups) {
          // do something after all updates are applied
          $('.carousel').carousel();
        }


        // JavaScript to be fired on the home page
        //window.sr = new ScrollReveal();
        sr.reveal('.home .list-services li', { duration: 1500 }, 50);
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };


  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
